<div class="nacha-customer-selector-modal">
  @if (data?.data?.match?.row) {
    <div class="modal-info">
      <mat-icon>info</mat-icon>
      <p>Select a customer for ID <strong>{{ data.data.match.row.individualIdNumber }}</strong> — "{{ data.data.match.row.individualName }}"</p>
    </div>
  }

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search Customers</mat-label>
    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="searchTerm$.next($event)" placeholder="Search by name or account number">
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  @if (filteredCustomers.length === 0 && searchTerm) {
    <div class="no-results">
      <mat-icon>search_off</mat-icon>
      <p>No customers found matching "{{ searchTerm }}"</p>
    </div>
  } @else if (filteredCustomers.length > 0) {
    <div class="customer-list">
      <p class="list-label">{{ searchTerm ? 'Search results' : 'All customers' }} ({{ filteredCustomers.length }} found):</p>
      <mat-radio-group [(ngModel)]="selectedCustomer" class="customer-radio-group">
        @for (customer of filteredCustomers; track customer.id) {
          <mat-radio-button [value]="customer" class="customer-option">
            <div class="customer-details">
              <div class="customer-name"><strong>{{ customer.displayName || customer.companyName }}</strong></div>
              @if (customer.companyAccountNumber) {
                <div class="customer-account">Account: {{ customer.companyAccountNumber }}</div>
              }
              @if (customer.contactEmail) {
                <div class="customer-email">{{ customer.contactEmail }}</div>
              }
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  } @else {
    <div class="no-results">
      <mat-icon>people_outline</mat-icon>
      <p>No customers available</p>
    </div>
  }
</div>
